module.exports = __webpack_public_path__ + "static/img/hand2-1.3c17d9a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/hand2-1.png
// module id = eqp/
// module chunks = 7